import {Outlet, useLocation} from 'react-router-dom';
import Header from './Header';
import {cn} from '@/utils';

const Layout = () => {
  const {pathname} = useLocation();
  if (
    HIDE_LAYOUT_PATHS.includes(
      pathname.startsWith('/') ? pathname.slice(1) : pathname,
    ) ||
    pathname == '/'
  ) {
    return <Outlet />;
  }

  return (
    <div
      className={cn(
        'w-full max-w-screen-xl mx-auto',
        'px-4 md:px-[2.625rem]',
        '[&_*]:box-border',
        'overscroll-none',
      )}>
      <Header />
      <main className='relative'>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;

const HIDE_LAYOUT_PATHS = ['select-lang', 'select-visit-type'];
